import React, { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTheme } from '../../context/ThemeContext';
import api from '../../services/api';
import { validateEmail } from '../../utils/emailValidation';
import { AuthTextField, MiddleDiv, PaperContainer, SpanInfo } from './styles';

const ForgotPasswordPage: React.FC = () => {
  const { isDarkMode } = useTheme();
  const [message, setMessage] = useState<string>('');
  const [emailError, setEmailError] = useState<boolean>(false);
  const [sentEmail, setSentEmail] = useState<boolean>(false);

  const forgotPasswordTheme = createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
    },
  });

  const checkPassword = useCallback(async (email: string) => {
    try {
      const response = await api.post('/users/checkPassword', {
        email,
        isReset: true,
      });
      return response.data;
    } catch (error: any) {
      console.error(error.response.data.message);
      return {};
    }
  }, []);

  const handleSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const email = data?.get('email')?.toString().toLowerCase() ?? '';

      const isValid = validateEmail(email);
      if (isValid) {
        // talvez seja necessario enviar mais um parametro para o backend saber quando é reset de senha ou quando é primeiro login
        // outra opçao é criar um fluxo somente para o reset senha
        const hasPassword = await checkPassword(email);
        if (sentEmail) {
          setMessage(
            'Wir senden Ihnen erneut einen neuen Link. Falls er nicht funktioniert, überprüfen Sie bitte, ob Sie Ihre E-Mail-Adresse korrekt eingegeben haben, oder kontaktieren Sie uns.',
          );
        } else {
          setMessage(
            hasPassword.status
              ? 'Das System hat ein Problem bei der Zurücksetzung des Passworts festgestellt. Bitte kontaktieren Sie uns.'
              : hasPassword.message,
          );
        }

        setEmailError(false);
        setSentEmail(true);
      } else {
        setEmailError(true);
      }
    },
    [checkPassword, sentEmail],
  );

  return (
    <ThemeProvider theme={forgotPasswordTheme}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <PaperContainer elevation={10}>
          <div
            style={{
              margin: '15px',
              height: '94%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ height: '120px' }}>
              <h2 style={{ margin: 0 }}>Passwort vergessen</h2>
              <hr
                style={{
                  borderWidth: '0px',
                  borderStyle: 'solid',
                  borderColor: '#E5EAF2',
                  borderBottomWidth: 'thin',
                  marginTop: '12px',
                  marginBottom: '15px',
                }}
                className="MuiDivider-root MuiDivider-fullWidth css-1vdax5c"
              ></hr>
              <SpanInfo>
                Haben Sie Ihr Passwort vergessen? Bitte geben Sie Ihre
                E-Mail-Adresse ein. Sie erhalten dann per E-Mail einen Link zur
                Erstellung eines neuen Passworts.
              </SpanInfo>
            </div>

            <MiddleDiv>
              <AuthTextField
                $autofillBg="#39393B"
                style={{ width: '100%' }}
                id="standard-basic"
                label="E-Mail Adresse"
                name="email"
                variant="standard"
                error={emailError}
                helperText={emailError ? 'Invalid email format' : ''}
              />
              <Button
                type="submit"
                style={{ marginTop: '20px' }}
                variant="outlined"
                disabled={sentEmail}
              >
                Passwort zurücksetzen
              </Button>
              {sentEmail && (
                <Button
                  type="submit"
                  style={{ marginTop: '20px', marginLeft: '10px' }}
                  variant="outlined"
                >
                  erneut versuchen
                </Button>
              )}

              {message !== '' && (
                <h4 style={{ color: '#4D50FF', fontWeight: 600 }}>{message}</h4>
              )}
            </MiddleDiv>

            <div style={{ height: '50px' }}>
              <hr
                style={{
                  borderWidth: '0px',
                  borderStyle: 'solid',
                  borderColor: '#E5EAF2',
                  borderBottomWidth: 'thin',
                  marginTop: '12px',
                  marginBottom: '5px',
                }}
                className="MuiDivider-root MuiDivider-fullWidth css-1vdax5c"
              ></hr>
              <Link href="/login" variant="body2">
                Passwort wieder eingefallen?
              </Link>
            </div>
          </div>
        </PaperContainer>
      </Box>
    </ThemeProvider>
  );
};

export default ForgotPasswordPage;
